import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=f9fd72ce&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=f9fd72ce&scoped=true&lang=css&"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=f9fd72ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fd72ce",
  null
  
)

export default component.exports